export enum PurchaseRequestDocumentUploadItemType {
  SPREADSHEET = 'spreadsheet',
  SUPPLIER_QUOTE = 'supplier-quote'
}

export interface PurchaseRequestDocumentUploadItemResult {
  type: PurchaseRequestDocumentUploadItemType;
  success: boolean;
  errors?: string[];
}
